import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const betSlice = createSlice({
  name: "bet",
  initialState: 0,
  reducers: {
    setBetAmount: (_state, action: PayloadAction<number>) => action.payload,
    clearBet:    () => 0,
  },
});

export const { setBetAmount, clearBet } = betSlice.actions;
export default betSlice.reducer;
